import { Base64 } from "@/utils/base64.min.js";

let index = {};
index.install = function (Vue) {
  // element 组件注册
  // Vue.use(ElementUI);
  // pdf导出组件注册
  // Vue.use(htmlToPdf);
  // Vue.use(vueAudioNative);

  // 注入全局方法
  Vue.prototype.$Base64 = Base64;
};

export default index;